import { render, staticRenderFns } from "./SGSSTFichaIndicadores.vue?vue&type=template&id=5208cca9"
import script from "./SGSSTFichaIndicadores.vue?vue&type=script&lang=js"
export * from "./SGSSTFichaIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports